const Messages = {
  info: {
    videoCreationStarted: "Creation started. Your new video will be added in 1-2 mins.",
    // autoStoryBoardStarted: "Storyboard is being auto-generated from the supplied YouTube video. Please allow 1-2 minutes for new shots to be created.",
    savingCut: 'Saving a cut of all the selected takes. How long will it take? A low res version takes about a minute and a higher resolution will follow.',
    savingCutTrimmed: 'Saving a cut trimmed to match the audio. How long will it take? A low res version takes about a minute and a higher resolution will follow.',
    videoGenerationStarted: "AI Generation in progress. Your new video will be added in 1-2 mins.",
    mediaUploadCompleted: "Upload complete. Your video is rendering and will be added in 1-2 mins.",
    autoStoryBoardStarted: "Storyboard is being auto-generated from the supplied video. Please allow 1-2 minutes for new shots to be created.", 
    videoCreationStarted: "Creation started. Your new video will be added in 1-2 mins.",
    savingCut: 'Saving a cut of all the selected takes. How long will it take? A low res version takes about a minute and a higher resolution will follow.',
    savingCutTrimmed: 'Saving a cut trimmed to match the audio. How long will it take? A low res version takes about a minute and a higher resolution will follow.', 
    videoGenerationStarted: "AI Generation in progress. Your new video will be added in 1-2 mins.",
    storyGenerationStarted: "AI Story Generation in progress. Your new storyboard will be completed in 2-3 mins.",
  },
  error: {
    noStoryError: 'No STORY, request failed to import media',
    errorCreatingImportRequest: 'Error creating import request', 
    projectForkFailed: "Error while forking from your account"
  }, 
  success: {
    projectForkedSuccessFully: "Project has been successfully forked to your account, please wait 1-2 min for all media to process."
  },
  loading: {
    waitingForFork: "Waiting for fork"
  }
};

export default Messages;
